export default "__VITE_ASSET__BLquBo3u__"